define('drops/mockList/mockList',[
    'jquery',
    'lq/drop',
    'lq/style'
], function ($, Drop, Style) {
    'use strict';

    var defaults = {
        data: {
            mockData: 'Header 1, Header 2, Header 3\nCell 1, Cell 2, Cell 3\nCell 4, Cell 5, Cell 6\n{1,2,1}',
            size: {
                x: 320,
                y: 90
            }
        }
    };

    function MockList(options) {
        Drop.call(this, $('<div class="mock-list" />'), defaults, options);
    };

    Drop.extend(MockList, Drop);

    MockList.typeName = 'MockList';

    MockList.prototype.applyStyles = function () {
        this.applyStyle(this.$element, '');
        this.applyStyle(this.$element.find('thead > tr'), 'header');
        this.applyStyle(this.$element.find('tbody > tr:even'), 'even');
        this.applyStyle(this.$element.find('tbody > tr:odd'), 'odd');
    };

    MockList.prototype.applyStyle = function ($element, styleName, customStyleName) {
        if (customStyleName == null)
            Style.renderStyles(this, null, $element, this.data.styles, styleName);
        else
            Style.renderStyles(this, null, $element, this.data.styles, styleName, customStyleName);
    };

    MockList.prototype.postRender = function () {
        this.applyPosition();
        this.renderTable();
        this.applyStyles();
    };
    
    MockList.prototype.rerenderTable = function () {
        this.$element.empty();
        this.renderTable();
        this.applyStyles();
    };

    MockList.prototype.renderTable = function () {
        if (!this.data.mockData) return;
        
        var parsedMockData = this.parseMockData();
        
        this.$element

            .append($('<table />')

                .append($('<thead>')
                    .append($('<tr />')
                        .append(_.map(parsedMockData.headers, function (header) {
                            return $('<th />')
                                .text(header.text.trim())
                                .css('width', header.width > 0 ? header.width + '%' : 'auto');
                        }))))

                .append($('<tbody>')
                    .append(_.map(parsedMockData.lines,
                        function (line) {
                            return $('<tr />')
                                .append(_.map(line,
                                    function (text) {
                                        return $('<td>').text(text.trim());
                                    }));
                        }))));
    };

    MockList.prototype.parseMockData = function () {
        var lines = this.data.mockData.split('\n');
        var sizes = null;

        if (lines.length !== 1) {
            sizes = _.last(lines).match(/^\{(.*)\}$/) || null;

            if (sizes) {
                lines.pop();

                sizes = _.map(sizes[1].split(','), function(size) {
                    return new Number(size);
                });

                var totalSize = _.reduce(sizes, function (memo, size) { return memo + size; }, 0);
                
                sizes = _.map(sizes, function (size) {
                    if (size === 0 || totalSize === 0) return 0;
                    return size / totalSize * 100;
                });
            } else {
                sizes = [];
            }
        }

        lines = _.map(lines, function(line) {
            return line.split(',');
        });

        var numberOfCells = _.chain(lines)
            .map(function(line) {
                return line.length;
            })
            .max(function(length) {
                return length;
            })
            .value();

        _.each(lines, function(line) {
            if (line.length === numberOfCells) return;
            for (var i = line.length; i < numberOfCells; i++)
                line.push('');
        });
        
        return {
            headers: _.map(lines.shift(), function(text, i) {
                return {
                    text: text,
                    width: sizes[i] || 0
                };
            }),
            lines: lines
        };
    };
    
    return MockList;
});
